import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import { Link, useLocation } from "react-router-dom";

export default function CustomButtonsRedirectSilos() {
    const { t } = useTranslation();
    const location = useLocation();

    // Ruta actual, por ejemplo: '/DetailsNaves/'
    const currentPath = location.pathname;

    return (
        <div>
            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <ButtonGroup>
                        <Link to="/DetailsSilos/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/DetailsSilos/'}
                            >
                                {t("Global_Label_Text_Details")}
                            </Button>
                        </Link>
                        <Link to="/InformationSilos/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/InformationSilos/'}
                            >
                                {t("Global_Label_Text_Information")}
                            </Button>
                        </Link>
                        <Link to="/NavesSilos/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/NavesSilos/'}
                            >
                                {t("Global_Label_Text_Ships")}
                            </Button>
                        </Link>
                        <Link to="/FoodReceiptsSilos/">
                            <Button
                                togglable={true}
                                selected={currentPath === '/FoodReceiptsSilos/'}
                            >
                                {t("Global_Label_Text_Food_Receipts")}
                            </Button>
                        </Link>
                    </ButtonGroup>
                </div>
            </div>
        </div>
    );
}